var _line, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAfterArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.171875,
    y1: 6.87844,
    x2: 13.0734,
    y2: 6.87844,
    stroke: "#2CD9B8",
    strokeWidth: 0.868114
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26953 0.972656C8.72386 4.50693 10.3118 5.50747 13.3409 7.04398",
    stroke: "#2CD9B8",
    strokeWidth: 0.868114
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26953 13.0312C8.72386 9.49697 10.3118 8.49643 13.3409 6.95992",
    stroke: "#2CD9B8",
    strokeWidth: 0.868114
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterArrow);
export default __webpack_public_path__ + "static/media/afterArrow.a2d89e64faf31ad9d71a183ea32d79d7.svg";
export { ForwardRef as ReactComponent };